import * as api from "../Services/api";
import ClientRoster from "../../objs/ClientRoster";
import Plan from "../../objs/Plan";
import ServicePlan from "../../objs/ServicePlan";
import Assignment from "../../objs/Assignment";

export const state = {
  clientRoster: [],
  plans: [],
  filters: {
    clientFilter: {},
    yearOfBirthFilter: {},
    districtFilter: {},
    districtAdminFilter: {},
    schoolFilter: {},
    teamFilter: {},
    groupSizeFilter: {},
    tenTwelveMonthFilter: {},
    languageFilter: {},
    locationFilter: {},
    semesterFilter: {},
    providerFilter: {},
    planStartDateFilter: [],
    planEndDateFilter: [],
    actualStartDateFilter: [],
    activePlansFilter: true,
  },
  selectedWorkview: null,
  displayColumns: [],
};
export const mutations = {
  SET_CLIENT_ROSTER(state, payload) {
    state.clientRoster = payload
      ? payload.map((item) => new ClientRoster(item))
      : [];
  },
  SET_PLANS(state, payload) {
    state.plans = payload ? payload.map((item) => new Plan(item)) : [];
  },
  ADD_PLAN(state, payload) {
    state.plans.push(new Plan(payload));
  },
  UPDATE_PLAN(state, payload) {
    state.plans = state.plans.map((item) => {
      return item.planId == payload.planId ? new Plan(payload) : item;
    });
  },
  ADD_SERVICE_PLAN(state, payload) {
    var plan = state.plans.find((item) => item.planId == payload.planId);
    plan.servicePlans.push(new ServicePlan(payload));
  },
  UPDATE_SERVICE_PLAN(state, payload) {
    var plan = state.plans.find((item) => item.planId == payload.planId);
    var index = plan.servicePlans.findIndex(
      (item) => item.servicePlanId === payload.servicePlanId
    );
    plan.servicePlans.splice(index, 1, new ServicePlan(payload));
  },
  ADD_PROVIDER_ASSIGNMENT(state, payload) {
    var plan = state.plans.find((item) =>
      item.servicePlans.some(
        (innerItem) => innerItem.servicePlanId == payload.servicePlanId
      )
    );
    var servicePlan = plan.servicePlans.find(
      (item) => item.servicePlanId == payload.servicePlanId
    );
    servicePlan.assignments.push(new Assignment(payload));
  },
  UPDATE_PROVIDER_ASSIGNMENT(state, payload) {
    var plan = state.plans.find((item) =>
      item.servicePlans.some(
        (item) => item.servicePlanId == payload.servicePlanId
      )
    );
    var servicePlan = plan.servicePlans.find(
      (item) => item.servicePlanId === payload.servicePlanId
    );
    var index = servicePlan.assignments.findIndex(
      (item) => item.assignmentId === payload.assignmentId
    );
    servicePlan.assignments.splice(index, 1, new Assignment(payload));
  },
  SET_FILTERS(state, payload) {
    state.filters[payload.filterName] = payload.filterValue;
  },
  CLEAR_FILTERS(state) {
    state.filters = {
      clientFilter: {},
      yearOfBirthFilter: {},
      districtFilter: {},
      districtAdminFilter: {},
      schoolFilter: {},
      teamFilter: {},
      groupSizeFilter: {},
      tenTwelveMonthFilter: {},
      languageFilter: {},
      locationFilter: {},
      semesterFilter: {},
      providerFilter: {},
      planStartDateFilter: [],
      planEndDateFilter: [],
      actualStartDateFilter: [],
      activePlansFilter: true,
    };
  },
  SET_WORKVIEW(state, payload) {
    state.selectedWorkview = payload;
  },
  CLEAR_WORKVIEW(state) {
    state.selectedWorkview = null;
  },
  SET_DISPLAY_COLUMNS(state, payload) {
    state.displayColumns = payload;
  },
};
export const getters = {
  getFilteredRoster(state, getters) {
    var roster = getters.getWorkviewRoster.filter((x) => {
      return (
        (!Boolean(state.filters.clientFilter.id) ||
          x.clientId == state.filters.clientFilter.id) &&
        (!Boolean(state.filters.yearOfBirthFilter.id) ||
          x.yearOfBirth == state.filters.yearOfBirthFilter.id) &&
        (!Boolean(state.filters.districtFilter.id) ||
          x.districtId == state.filters.districtFilter.id) &&
        (!Boolean(state.filters.districtAdminFilter.id) ||
          x.districtAdminId == state.filters.districtAdminFilter.id) &&
        (!Boolean(state.filters.schoolFilter.id) ||
          (x.schoolId == null && state.filters.schoolFilter.id == "none") ||
          x.schoolId == state.filters.schoolFilter.id) &&
        (!Boolean(state.filters.teamFilter.id) ||
          (x.teamId == null && state.filters.teamFilter.id == "none") ||
          x.teamId == state.filters.teamFilter.id) &&
        (!Boolean(state.filters.groupSizeFilter.id) ||
          x.groupSize == state.filters.groupSizeFilter.id) &&
        (!Boolean(state.filters.tenTwelveMonthFilter.id) ||
          x.tenTwelveMonth === state.filters.tenTwelveMonthFilter.id) &&
        (!Boolean(state.filters.languageFilter.id) ||
          x.languageId == state.filters.languageFilter.id) &&
        (!Boolean(state.filters.locationFilter.id) ||
          x.sessionLocationId == state.filters.locationFilter.id) &&
        (!Boolean(state.filters.semesterFilter.id) ||
          x.semesterCode == state.filters.semesterFilter.id) &&
        (!Boolean(state.filters.providerFilter.id) ||
          (x.providerId == null && state.filters.providerFilter.id == "none") ||
          x.providerId == state.filters.providerFilter.id) &&
        // date filters
        (!Boolean(state.filters.planStartDateFilter.length) ||
          state.filters.planStartDateFilter.some((item) => {
            return (
              new Date(x.servicePlanStartDate).getMonth() ==
                item.id.getMonth() &&
              new Date(x.servicePlanStartDate).getFullYear() ==
                item.id.getFullYear()
            );
          })) &&
        (!Boolean(state.filters.planEndDateFilter.length) ||
          state.filters.planEndDateFilter.some((item) => {
            return (
              new Date(x.servicePlanEndDate).getMonth() == item.id.getMonth() &&
              new Date(x.servicePlanEndDate).getFullYear() ==
                item.id.getFullYear()
            );
          })) &&
        (!Boolean(state.filters.actualStartDateFilter.length) ||
          state.filters.actualStartDateFilter.some((item) => {
            return (
              new Date(x.actualStartDate).getMonth() == item.id.getMonth() &&
              new Date(x.actualStartDate).getFullYear() == item.id.getFullYear()
            );
          })) &&
        (state.filters.activePlansFilter === false || x.isActivePlan)
      );
    });
    return roster;
  },
  getWorkviewRoster(state) {
    var roster = state.clientRoster.filter((x) => {
      switch (state.selectedWorkview) {
        case "expiringPlans":
          return x.isExpiring;
        case "pendingAssignment":
          return x.isPendingAssignment;
        case "pendingApproval":
          return x.isPendingApproval;
        case "awaitingFADSubmission":
          return x.isAwaitingFADSubmission;
        default:
          return true;
      }
    });
    return roster;
  },
};
export const actions = {
  async getClientRoster({ commit }, data) {
    return api.getQuery("/plan/getClientRoster", data).then((response) => {
      if (response.success) {
        commit("SET_CLIENT_ROSTER", response.data);
      }
      return response.success;
    });
  },
  async getPlansByClient({ commit }, data) {
    return await api
      .getQuery("/plan/getPlansByClient", { clientId: data })
      .then((response) => {
        if (response.success) {
          commit("SET_PLANS", response.data);
        }
        return response.success;
      });
  },
  async createPlan({ commit }, data) {
    return await api.post("/plan/createPlan", data).then((response) => {
      if (response.success) {
        commit("ADD_PLAN", response.data);
        return "";
      }
      return response.message;
    });
  },
  async updatePlan({ commit }, data) {
    return await api.post("/plan/updatePlan", data).then((response) => {
      if (response.success) {
        commit("UPDATE_PLAN", response.data);
        return "";
      }
      return response.message;
    });
  },
  async createServicePlan({ commit }, data) {
    return await api.post("/plan/createServicePlan", data).then((response) => {
      if (response.success) {
        commit("ADD_SERVICE_PLAN", response.data);
        return "";
      }
      return response.message;
    });
  },
  async updateServicePlan({ commit }, data) {
    return await api.post("/plan/updateServicePlan", data).then((response) => {
      if (response.success) {
        commit("UPDATE_SERVICE_PLAN", response.data);
        return "";
      }
      return response.message;
    });
  },
  async createProviderAssignment({ commit }, data) {
    return await api.post("/plan/createAssignment", data).then((response) => {
      if (response.success) {
        commit("ADD_PROVIDER_ASSIGNMENT", response.data);
        return "";
      }
      return response.message;
    });
  },
  async updateProviderAssignment({ commit }, data) {
    return await api.post("/plan/updateAssignment", data).then((response) => {
      if (response.success) {
        commit("UPDATE_PROVIDER_ASSIGNMENT", response.data);
        return "";
      }
      return response.message;
    });
  },
  async setFADSubmitted({}, data) {
    return await api
      .postQuery("/plan/setFADSubmitted", data)
      .then((response) => {
        if (response.success) {
          return "";
        }
        return response.message;
      });
  },
  setFilters({ commit }, data) {
    commit("SET_FILTERS", data);
  },
  clearFilters({ commit }) {
    commit("CLEAR_FILTERS");
  },
  setWorkview({ commit }, data) {
    commit("SET_WORKVIEW", data);
  },
  clearWorkview({ commit }) {
    commit("CLEAR_WORKVIEW");
  },
  setDisplayColumns({ commit }, data) {
    commit("SET_DISPLAY_COLUMNS", data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
